// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.custom-select-filter {
  padding: 8px;
  min-width: 250px;
  max-width: 300px;
  display: flex;
  flex-direction: column;
  gap: 8px;
  background-color: var(--color-white);
}

/* Search input */
.filter-search {
  width: 100%;
}

.filter-search-input {
  width: 100%;
  padding: 6px 10px;
  border: 1px solid #ccc;
  border-radius: 4px;
  font-size: 14px;
  box-sizing: border-box;
}

.filter-search-input:focus {
  outline: none;
  border-color: #4CAF50;
  box-shadow: 0 0 0 2px rgba(76, 175, 80, 0.2);
}

/* Actions (Select All) */
.filter-actions {
  border-bottom: 1px solid #eee;
  padding-bottom: 6px;
}

/* Options list */
.filter-options-list {
  max-height: 250px;
  overflow-y: auto;
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.filter-options-list::-webkit-scrollbar {
  width: 8px;
}

.filter-options-list::-webkit-scrollbar-track {
  background: #f1f1f1;
  border-radius: 4px;
}

.filter-options-list::-webkit-scrollbar-thumb {
  background: #888;
  border-radius: 4px;
}

.filter-options-list::-webkit-scrollbar-thumb:hover {
  background: #555;
}

/* Checkbox items */
.filter-checkbox-item {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 6px 8px;
  cursor: pointer;
  border-radius: 4px;
  transition: background-color 0.2s;
  margin: 0;
}

.filter-checkbox-item:hover {
  background-color: #f5f5f5;
}

.filter-checkbox-item input[type="checkbox"] {
  cursor: pointer;
  width: 16px;
  height: 16px;
  margin: 0;
}

.filter-checkbox-label {
  flex: 1 1;
  font-size: 14px;
  -webkit-user-select: none;
          user-select: none;
  color: #333;
}

/* No results message */
.filter-no-results {
  padding: 12px;
  text-align: center;
  color: #999;
  font-size: 14px;
  font-style: italic;
}

/* Footer with Apply/Reset Buttons */
.filter-footer-buttons {
  display: flex;
  justify-content: space-between;
  gap: 8px;
  padding-top: 8px;
  border-top: 1px solid #eee;
}

.filter-reset-btn,
.filter-apply-btn {
  flex: 1 1;
  padding: 6px 12px;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  font-size: 13px;
  font-weight: 500;
  transition: background-color 0.2s;
}

.filter-reset-btn {
  background-color: #f5f5f5;
  color: #333;
  border: 1px solid var(--color-border-light);
}

.filter-reset-btn:hover {
  background-color: #e0e0e0;
}

.filter-reset-btn:active {
  background-color: #d0d0d0;
}

.filter-apply-btn {
  background-color: var(--color-primary-green);
  color: var(--color-white);
}

.filter-apply-btn:hover {
  background-color:var(--color-primary-green);
}

.filter-apply-btn:active {
  background-color: var(--color-primary-green);
}

/* Dependency notice for DependentCustomSelectFilter */
.filter-dependency-notice {
  font-size: 11px;
  color: #666;
  padding: 4px 8px;
  background-color: #f0f8ff;
  border-left: 3px solid #007bff;
  border-radius: 3px;
  font-style: italic;
}`, "",{"version":3,"sources":["webpack://./src/shared/components/listview/CustomSelectFilter.css"],"names":[],"mappings":"AAAA;EACE,YAAY;EACZ,gBAAgB;EAChB,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,oCAAoC;AACtC;;AAEA,iBAAiB;AACjB;EACE,WAAW;AACb;;AAEA;EACE,WAAW;EACX,iBAAiB;EACjB,sBAAsB;EACtB,kBAAkB;EAClB,eAAe;EACf,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,4CAA4C;AAC9C;;AAEA,yBAAyB;AACzB;EACE,6BAA6B;EAC7B,mBAAmB;AACrB;;AAEA,iBAAiB;AACjB;EACE,iBAAiB;EACjB,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;AAClB;;AAEA,mBAAmB;AACnB;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,gBAAgB;EAChB,eAAe;EACf,kBAAkB;EAClB,iCAAiC;EACjC,SAAS;AACX;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,eAAe;EACf,WAAW;EACX,YAAY;EACZ,SAAS;AACX;;AAEA;EACE,SAAO;EACP,eAAe;EACf,yBAAiB;UAAjB,iBAAiB;EACjB,WAAW;AACb;;AAEA,uBAAuB;AACvB;EACE,aAAa;EACb,kBAAkB;EAClB,WAAW;EACX,eAAe;EACf,kBAAkB;AACpB;;AAEA,oCAAoC;AACpC;EACE,aAAa;EACb,8BAA8B;EAC9B,QAAQ;EACR,gBAAgB;EAChB,0BAA0B;AAC5B;;AAEA;;EAEE,SAAO;EACP,iBAAiB;EACjB,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,iCAAiC;AACnC;;AAEA;EACE,yBAAyB;EACzB,WAAW;EACX,2CAA2C;AAC7C;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,4CAA4C;EAC5C,yBAAyB;AAC3B;;AAEA;EACE,2CAA2C;AAC7C;;AAEA;EACE,4CAA4C;AAC9C;;AAEA,sDAAsD;AACtD;EACE,eAAe;EACf,WAAW;EACX,gBAAgB;EAChB,yBAAyB;EACzB,8BAA8B;EAC9B,kBAAkB;EAClB,kBAAkB;AACpB","sourcesContent":[".custom-select-filter {\n  padding: 8px;\n  min-width: 250px;\n  max-width: 300px;\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n  background-color: var(--color-white);\n}\n\n/* Search input */\n.filter-search {\n  width: 100%;\n}\n\n.filter-search-input {\n  width: 100%;\n  padding: 6px 10px;\n  border: 1px solid #ccc;\n  border-radius: 4px;\n  font-size: 14px;\n  box-sizing: border-box;\n}\n\n.filter-search-input:focus {\n  outline: none;\n  border-color: #4CAF50;\n  box-shadow: 0 0 0 2px rgba(76, 175, 80, 0.2);\n}\n\n/* Actions (Select All) */\n.filter-actions {\n  border-bottom: 1px solid #eee;\n  padding-bottom: 6px;\n}\n\n/* Options list */\n.filter-options-list {\n  max-height: 250px;\n  overflow-y: auto;\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n}\n\n.filter-options-list::-webkit-scrollbar {\n  width: 8px;\n}\n\n.filter-options-list::-webkit-scrollbar-track {\n  background: #f1f1f1;\n  border-radius: 4px;\n}\n\n.filter-options-list::-webkit-scrollbar-thumb {\n  background: #888;\n  border-radius: 4px;\n}\n\n.filter-options-list::-webkit-scrollbar-thumb:hover {\n  background: #555;\n}\n\n/* Checkbox items */\n.filter-checkbox-item {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  padding: 6px 8px;\n  cursor: pointer;\n  border-radius: 4px;\n  transition: background-color 0.2s;\n  margin: 0;\n}\n\n.filter-checkbox-item:hover {\n  background-color: #f5f5f5;\n}\n\n.filter-checkbox-item input[type=\"checkbox\"] {\n  cursor: pointer;\n  width: 16px;\n  height: 16px;\n  margin: 0;\n}\n\n.filter-checkbox-label {\n  flex: 1;\n  font-size: 14px;\n  user-select: none;\n  color: #333;\n}\n\n/* No results message */\n.filter-no-results {\n  padding: 12px;\n  text-align: center;\n  color: #999;\n  font-size: 14px;\n  font-style: italic;\n}\n\n/* Footer with Apply/Reset Buttons */\n.filter-footer-buttons {\n  display: flex;\n  justify-content: space-between;\n  gap: 8px;\n  padding-top: 8px;\n  border-top: 1px solid #eee;\n}\n\n.filter-reset-btn,\n.filter-apply-btn {\n  flex: 1;\n  padding: 6px 12px;\n  border: none;\n  border-radius: 4px;\n  cursor: pointer;\n  font-size: 13px;\n  font-weight: 500;\n  transition: background-color 0.2s;\n}\n\n.filter-reset-btn {\n  background-color: #f5f5f5;\n  color: #333;\n  border: 1px solid var(--color-border-light);\n}\n\n.filter-reset-btn:hover {\n  background-color: #e0e0e0;\n}\n\n.filter-reset-btn:active {\n  background-color: #d0d0d0;\n}\n\n.filter-apply-btn {\n  background-color: var(--color-primary-green);\n  color: var(--color-white);\n}\n\n.filter-apply-btn:hover {\n  background-color:var(--color-primary-green);\n}\n\n.filter-apply-btn:active {\n  background-color: var(--color-primary-green);\n}\n\n/* Dependency notice for DependentCustomSelectFilter */\n.filter-dependency-notice {\n  font-size: 11px;\n  color: #666;\n  padding: 4px 8px;\n  background-color: #f0f8ff;\n  border-left: 3px solid #007bff;\n  border-radius: 3px;\n  font-style: italic;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
